<template>
	<dl class="c-key-value">
		<template v-for="item in items">
			<dt class="c-key-value__key" :key="item.key" v-if="semiColon">
				{{item.key}}:
			</dt>
			<dt class="c-key-value__key" :key="item.key" v-else>
				{{item.key}}
			</dt>
			<dd class="c-key-value__value" v-for="value in item.value" v-html="value" :key="value"/>
		</template>
	</dl>
</template>

<script>
export default {
	name: 'VKeyValue',
	props: {
		semiColon: {
			type: Boolean,
			default: false
		},
		items: {
			type: Array,
			default: []
		}
	}
}
</script>